import { Box, TableCell, Typography } from "@mui/material";
import { Clamp } from "../clamp/clamp";
import { FirewatchChip } from "./FirewatchChip";
import { DynamicIcon } from "../icons/DynamicIcon";
import { Icon_Ids, Tag } from "~/operations";
import { ExceptionChip } from "~/components";

type AssetCellProps = {
  title?: string;
  tags?: (Tag | null)[] | null | undefined;
  iconId?: Icon_Ids | null;
  isPendingException?: boolean;
  isRiskAccepted?: boolean;
  isDisabled?: boolean;
  isWorkaround?: boolean;
  isFalsePositive?: boolean;
  exceptionTooltipProps?: {
    title: string | React.ReactNode;
  };
};

export function AssetCell({
  title,
  tags,
  iconId,
  isPendingException,
  isRiskAccepted = false,
  isDisabled = false,
  isFalsePositive = false,
  isWorkaround = false,
  exceptionTooltipProps,
}: AssetCellProps) {
  const _tags = tags?.filter((x): x is Tag => x !== null);

  const hasException = isPendingException || isRiskAccepted || isDisabled;

  return (
    <TableCell>
      <Clamp>
        <Typography
          sx={{
            display: "flex",
            alignItems: "center",
            fontSize: 14,
            lineHeight: "16px",
            gap: 1,
            fontWeight: 700,
            color: hasException ? "text.secondary" : "text.primary",
          }}
          data-testid="asset-id"
        >
          <DynamicIcon iconId={iconId} />
          {title}
        </Typography>
      </Clamp>
      <Box
        display="flex"
        alignItems="center"
        gap={1}
        mt={hasException || (_tags?.length || 0) > 0 ? 1 : 0}
      >
        {hasException && (
          <ExceptionChip
            isRiskAccepted={isRiskAccepted}
            isDisabled={isDisabled}
            isWorkaround={isWorkaround}
            isFalsePositive={isFalsePositive}
            TooltipProps={exceptionTooltipProps}
          />
        )}
        <Box display="flex" gap={1}>
          {_tags?.map((tag) => (
            <FirewatchChip key={tag.key} tag={tag} inactive={hasException} />
          ))}
        </Box>
      </Box>
    </TableCell>
  );
}
